import { render, staticRenderFns } from "./TermsAndConditionsTable.vue?vue&type=template&id=35064c64"
import script from "./TermsAndConditionsTable.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports